import type { TFunction } from 'i18next';
import { ROUTES } from '@app/routes';
import {
  HomeIcon,
  BreathworksIcon,
  JourneysIcon,
  ActivityIcon,
  AchievementsIcon,
  PricingIcon,
} from '../Icons';

export function getNavItems(t: TFunction<'nav'>) {
  return [
    { to: ROUTES.loggedInHome, label: t('home'), icon: <HomeIcon />, end: true },
    { to: ROUTES.breathworks, label: t('breathworks'), icon: <BreathworksIcon />, end: false },
    { to: ROUTES.journeys, label: t('journeys'), icon: <JourneysIcon />, end: false },
    { to: ROUTES.pricing, label: t('pricing'), icon: <PricingIcon />, end: false },
    { to: ROUTES.activity, label: t('activity'), icon: <ActivityIcon />, end: false },
    { to: ROUTES.achievements, label: t('achievements'), icon: <AchievementsIcon />, end: false },
  ];
}
